<div class="global-bg">
    <div style="flex: 1;"></div>
    <app-form class="form"></app-form>
    <div style="flex: 1;"></div>
</div>